export const LocalStorage = {
  get: (key) => localStorage.getItem(key),
  set: (key, value) => {
    localStorage.setItem(key, value);
  },
  remove: (key) => {
    localStorage.removeItem(key);
  },
  clear: () => {
    localStorage.clear();
    window.location = window.location.toString();
  },
};
